import {fetchReportRoster} from './fetchReportRoster'

export const roster = {
  fetchReportRoster,
}
